module.exports = __webpack_public_path__ + "2a90bfaf5f7b9348a415947804a6cdd2.jpg";